/**
 * Deep-link state for the Incident View detail modal: `?incident=<id>`.
 * The mechanics are shared with Document View; see lib/modalUrl.
 */

import { modalUrl } from './modalUrl';

export const INCIDENT_PARAM = 'incident';

/** Marker on history entries this module pushed, so close can pop them. */
export const HISTORY_MARKER = 'airiIncident';

const incidentUrl = modalUrl(INCIDENT_PARAM, HISTORY_MARKER);

/** The incident id in `search`, or null when absent or not a plausible id. */
export const readIncidentParam = incidentUrl.read;

/** `href` with the incident param set to `id`, or removed when `id` is null. */
export const withIncidentParam = incidentUrl.withParam;

/** Record an opened modal: a new history entry, unless the URL already names it. */
export const pushIncident = incidentUrl.push;

/** Record a closed modal (see ModalUrl.clear). */
export const clearIncident = incidentUrl.clear;
